/**
 * @generated SignedSource<<438da15ebf966b00870f35192a145c4d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetWeatherSize = "ONE_X_ONE" | "TWO_X_ONE";
export type PreviewWidgetWeatherInput = {
  lat?: number | null;
  lng?: number | null;
  placeId?: string | null;
  size?: WidgetWeatherSize | null;
  storecastId?: string | null;
};
export type WAWeatherPreviewQuery$variables = {
  input: PreviewWidgetWeatherInput;
  storecastId: string;
};
export type WAWeatherPreviewQuery$data = {
  readonly dashboard: {
    readonly previewWidgetWeather: {
      readonly " $fragmentSpreads": FragmentRefs<"WidgetWeather_widget">;
    };
  };
};
export type WAWeatherPreviewQuery = {
  response: WAWeatherPreviewQuery$data;
  variables: WAWeatherPreviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storecastId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "storecastId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "condition",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WAWeatherPreviewQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*: any*/),
          "concreteType": "Dashboard",
          "kind": "LinkedField",
          "name": "dashboard",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": (v2/*: any*/),
              "concreteType": "WidgetWeather",
              "kind": "LinkedField",
              "name": "previewWidgetWeather",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WidgetWeather_widget"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WAWeatherPreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Dashboard",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "WidgetWeather",
            "kind": "LinkedField",
            "name": "previewWidgetWeather",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "size",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "WidgetWeatherOccasion",
                "kind": "LinkedField",
                "name": "currentOccasion",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "temp",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "WidgetWeatherOccasion",
                "kind": "LinkedField",
                "name": "occasions",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "date",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lowTemp",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "highTemp",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5fde29571444cfd8b5975efe4aa29558",
    "id": null,
    "metadata": {},
    "name": "WAWeatherPreviewQuery",
    "operationKind": "query",
    "text": "query WAWeatherPreviewQuery(\n  $input: PreviewWidgetWeatherInput!\n  $storecastId: ID!\n) {\n  dashboard(id: $storecastId) {\n    previewWidgetWeather(input: $input) {\n      ...WidgetWeather_widget\n      id\n    }\n    id\n  }\n}\n\nfragment WidgetWeatherBackground_WidgetWeather on WidgetWeather {\n  currentOccasion {\n    condition\n  }\n}\n\nfragment WidgetWeatherConditionIcon_WeatherOccasion on WidgetWeatherOccasion {\n  condition\n}\n\nfragment WidgetWeatherCurrentPane_weatherOccasion on WidgetWeatherOccasion {\n  temp\n  description\n}\n\nfragment WidgetWeatherDatePaneListItem_WeatherOccasion on WidgetWeatherOccasion {\n  date\n  condition\n  lowTemp\n  highTemp\n  ...WidgetWeatherConditionIcon_WeatherOccasion\n}\n\nfragment WidgetWeather_widget on WidgetWeather {\n  id\n  title\n  size\n  ...WidgetWeatherBackground_WidgetWeather\n  currentOccasion {\n    ...WidgetWeatherCurrentPane_weatherOccasion\n  }\n  occasions {\n    date\n    ...WidgetWeatherDatePaneListItem_WeatherOccasion\n  }\n}\n"
  }
};
})();

(node as any).hash = "59249e6525085f9e371b38ac29ec2bd5";

export default node;
